import { UNSUBSCRIBE_REQUEST, UNSUBSCRIBE_REQUEST_DONE, UNSUBSCRIBE_REQUEST_ERROR, UNSUBSCRIBE_REQUEST_RESET } from './actionTypes';
export const unsubscribeRequest = (data) => ({
    type: UNSUBSCRIBE_REQUEST,
    data
});
export const unsubscribeRequestDone = () => ({
    type: UNSUBSCRIBE_REQUEST_DONE
});
export const unsubscribeRequestError = (data) => ({
    type: UNSUBSCRIBE_REQUEST_ERROR,
    data
});
export const unsubscribeRequestReset = () => ({
    type: UNSUBSCRIBE_REQUEST_RESET
});
//# sourceMappingURL=actionCreators.js.map